import type { ErrorName } from "../types/errors/ErrorName"

export function EngineError(code: ErrorName) {
  return new Error(code)
}
